import { render, staticRenderFns } from "./registerAdminPage.vue?vue&type=template&id=0949910c&scoped=true&"
import script from "./registerAdminPage.vue?vue&type=script&lang=ts&"
export * from "./registerAdminPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0949910c",
  null
  
)

export default component.exports